import { useCallback, useEffect } from 'react';

// This calculates left position of "child" if we want it to be center placed in "parent"
const calcLeftCenter = (parent, child, childIndex) =>
  child.clientWidth * childIndex - 148 * childIndex;

export const useCarouselData = ({
  carouselRef,
  childrenRef,
  selectedIndex,
}) => {
  // When user clicks on any child of our carousel, we want to scroll it into center
  const scrollToChild = useCallback(
    (childIndex) => {
      const carousel = carouselRef.current;
      const child = childrenRef.current && childrenRef.current[childIndex];

      if (!carousel || !child) {
        return;
      }

      carousel.scrollTo({
        left: calcLeftCenter(carousel, child, childIndex),
        behavior: 'smooth',
      });
    },
    [carouselRef, childrenRef]
  );

  // Scroll to selected child, in case user scrolled to the side
  const scrollToSelected = useCallback(() => {
    if (selectedIndex >= 0) {
      scrollToChild(selectedIndex);
    }
  }, [scrollToChild, selectedIndex]);

  // Scroll to newly selected child
  useEffect(() => {
    scrollToSelected();
  }, [scrollToSelected]);

  return {
    scrollToSelected,
  };
};
